<div class="bg-white p-5 border-round-2xl box-shadow">
  <div class="header mb-5 flex justify-content-between">
    <div>
      <span class="title"> {{ header }} </span> <br />
      <span class="subtitle" *ngIf="!expensesByCategory"> {{subtitle}}</span> <br />

      <span class="subtitle" *ngIf="!monthToMonthResultReportYearFilter && !expensesByCategory"
        >Últimos 12 meses</span
      >
    </div>
    <div *ngIf="!expensesByCategory">
      <div class="flex align-items-center">
        <!-- FILTRO -->
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="flex justify-content-center"> 
    <p-progressSpinner *ngIf="loading" ariaLabel="loading"></p-progressSpinner>
  </div>
  <div class="grid" *ngIf="!expensesByCategory" >
    <div class="col-6" [hidden]="loading">
      <div *ngFor="let column of columns; let index = index" [class]="">
        <div class="mb-5" *ngIf="index < 6">
          <split-report-message-year-month
            *ngIf="index == 0"
            [class]="expenses? 'expense-card' :'green-card'"
            [month]="column.data.split('-')[1]"
            [year]="column.data.split('-')[0]"
            [label]="'Faturamento total'"
            [columns]="column.columns"
            [expense]="expenses ? true : false"
          ></split-report-message-year-month>
          <split-report-message-year-month
            *ngIf="index > 0"
            [class]=" expenses ? 'expense_not_current_card' : 
              column.columns[0].valor < 0 ? 'negative-card' : 'positive-card'
            "
            [month]="column.data.split('-')[1]"
            [year]="column.data.split('-')[0]"
            [label]="'Faturamento total'"
            [columns]="column.columns"
            [expense]="expenses ? true : false"
          ></split-report-message-year-month>
        </div>
      </div>
    </div>
    <div class="col-6" [hidden]="loading">
      <div *ngFor="let column of columns; let index = index" [class]="">
        <div class="mb-5" *ngIf="index > 5">
          <split-report-message-year-month
            [class]=" expenses ? 'expense_not_current_card' : 
              column.columns[0].valor < 0 ? 'negative-card' : 'positive-card'
            "
         
            [month]="column.data.split('-')[1]"
            [year]="column.data.split('-')[0]"
            [label]="'Faturamento total'"
            [columns]="column.columns"
            [percentage]="column.percentage"
            [expense]="expenses ? true : false"
          ></split-report-message-year-month>
        </div>
      </div>
    </div>
  </div>
  <div class="grid" *ngIf="expensesByCategory">
    <div class="col-12">
      <div
        *ngFor="
          let expense of expensesArray.slice(first, first + 3);
          let index = index
        "
        [class]=""
      >
        <div class="mb-5 flex" [ngClass]="index == 0 && first == 0 ? 'expenses' : 'expenses_not_current'">
          <div
            class="year_month flex align-items-center flex-column justify-content-center h-5rem"
          >
            <div class="month">{{ expense.month }} </div> 
            <div class="year">{{ expense.year }}</div>
          </div>

          <div class=" content w-full flex align-items-center justify-content-around">

            <div  *ngFor="let expenseCatergory of expense.expenses">
              <div class="value">
                {{expenseCatergory.value}}
              </div>
              <div class="description">
                {{expenseCatergory.name}}
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 flex justify-content-center">
    <div *ngIf="enablePaginator" style="width: 400px">
      <p-paginator
        [rows]="3"
        [totalRecords]="expensesArray.length"
        (onPageChange)="onPageChange($event)"
      ></p-paginator>
    </div>
  </div>
</div>
